import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type PendingTemplatesSliceState = {
    pendingTemplates: string[];
};

const pendingTemplatesInitialState: PendingTemplatesSliceState = {
    pendingTemplates: [],
};

export const PENDING_TEMPLATES_REDUCER_NAME = 'pendingTemplates';

export const pendingTemplatesSlice = createSlice({
    name: PENDING_TEMPLATES_REDUCER_NAME,
    initialState: pendingTemplatesInitialState,
    reducers: {
        setPendingTemplates: (
            state,
            action: PayloadAction<{
                pendingTemplates: string[];
            }>,
        ) => {
            state.pendingTemplates = action.payload.pendingTemplates;
        },
    },
});

export const { setPendingTemplates } = pendingTemplatesSlice.actions;

export const pendingTemplatesReducer = pendingTemplatesSlice.reducer;
